import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
// import { FaUserCircle } from 'react-icons/fa';
import backgroundDetailContact from '../assets/backgroundDetailContact.svg';
import iconEditContact from '../assets/iconEditContact.svg';
import userImageProfile from '../assets/userImageProfile.svg'
import CardContacto from "./CardContacto.jsx";
import { getAllsClientesByProductorId, getAllContactsByProductorId } from "../../endpoints.js"
// import { useWindowWidth } from "@react-hook/window-size";


const DetailAsesor =
  ({
    user,
    selectedProductor
  }) => {

    const scrollContainerRef = useRef(null);
    const [clientesProductor, setClientesProductor] = useState([]);
    const [contactosProductor, setContactosProductor] = useState([]);
    const [totalContacts, setTotalContacts] = useState(0);
    const [loading2, setLoading2] = useState(false);
    const [selectedContact, setSelectContact] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [selectedOptions, setSelectedOptions] = useState(1);

    const getInfoReporte = async (selectedProductor) => {
      setLoading2(true)
      getAllsClientesByProductorId({
        userId: selectedProductor.id,
        userType: "Productor",
        page: currentPage

      }).then((res) => {
        if (res?.status === 200) {
          setClientesProductor(res.data.clientes)
        } else {
          console.log(res)
        }
      })
    }

    const getInfoReporteContactos = (selectedProductor) => {
      setLoading2(true)
      getAllContactsByProductorId(
        {
          userId: selectedProductor.id,
          userType: "Productor",
          page: currentPage
        }
      ).then((res) => {
        if (res.status === 200) {
          console.log(res.data)
          setContactosProductor(res.data.contacts)
          setTotalContacts(res.data.total)
        } else {
          console.log(res)
        }
      })
    }

    useEffect(() => {
      getInfoReporte(selectedProductor)
      getInfoReporteContactos(selectedProductor)
    }, [selectedProductor.id, selectedOptions]);

    const handleNextPage = (currentPage) => {
      if (currentPage <= totalPages) {
        let auxCurrent = currentPage + 1;
        setCurrentPage(auxCurrent);
      } else {
      }
    };

    useEffect(() => {
      console.log(currentPage, "CONSOLE LOG CURRENT PAGE")
      setLoading2(true)
      getInfoReporte(selectedProductor)
    }, [currentPage]);

    useEffect(() => {
      const scrollContainer = scrollContainerRef.current;
      const handleScroll = () => {
        if (scrollContainer.scrollHeight - scrollContainer.scrollTop === scrollContainer.clientHeight) {
          console.log("siguiente pagina")
          console.log(currentPage, "Dentro del scroll")
          handleNextPage(currentPage);
        }
      };
      scrollContainer.addEventListener('scroll', handleScroll);
      return () => {
        scrollContainer.removeEventListener('scroll', handleScroll);
      };
    }, [currentPage, scrollContainerRef.current]);


    return (
      <DivBoxContainer>
        <DivContainer>
          <DivContentImage src={backgroundDetailContact} />
          {
            user.type !== "Admin" || user.type !== "Supervisor" ?
              null :
              <ContainerBtnEditar src={iconEditContact} />
          }
          <DivColumnRelative>
            <ImageProfile src={selectedProductor?.imagen_profile || userImageProfile} />
            <TextNameUser>
              <b>{selectedProductor?.name} {selectedProductor.lastname}</b>
            </TextNameUser>
          </DivColumnRelative>
        </DivContainer>
        <DivColumn1
          style={{
            marginTop: "5vh"
          }}
        >
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            alignContent: 'flex-start',
            justifyContent: 'space-between',
            width: '-webkit-fill-available',
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
            }}>
              <Text1 style={{
                fontSize: '16px',
                margin: '0px 0px 8px 0px'
              }}><b>Datos del productor</b></Text1>
              <Text1><b>Teléfono: </b>{selectedProductor.phone}</Text1>
              <Text1><b>Email:</b> {selectedProductor.email}</Text1>
            </div>
          </div>
        </DivColumn1>
        <DivColumn1
          style={{
            marginTop: "8px"
          }}>
          <TextSeccion>
            Contactos {totalContacts}
          </TextSeccion>
          <ScrollContainer ref={scrollContainerRef}>
            {contactosProductor?.length > 0 ? (
              contactosProductor.map((data) => (
                <CardContacto
                  key={data.id}
                  contact={data}
                  setIdContact={setSelectContact}
                  selectedContact={selectedContact}
                />
              ))
            ) : (
              null
            )}
          </ScrollContainer>
        </DivColumn1>
        <DivColumn1
          style={{
            marginTop: "8px"
          }}>
          <TextSeccion>
            Clientes {clientesProductor?.length}
          </TextSeccion>
          <ScrollContainer ref={scrollContainerRef}>
            {clientesProductor?.length > 0 ? (
              clientesProductor.map((data) => (
                <CardContacto
                  key={data.id}
                  contact={data}
                  setSelectContact={setSelectContact}
                  selectedContact={selectedContact}
                />
              ))
            ) : (
              null
            )}
          </ScrollContainer>
        </DivColumn1>
      </DivBoxContainer>
    );
  };

export default DetailAsesor;

const TextSeccion = styled.span`
  font-size: 16px;
  margin: 0px 0px 8px;
  width: auto;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 16px;
  color: #003049;
`;

const ScrollContainer = styled.div`
  width: -webkit-fill-available;
  height: auto;
  max-height: 30vh !important;
  min-height: 150px !important;
  overflow-y: auto;
  overflow-x: hidden;
  gap: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0%;
  scroll-behavior: smooth;
  padding: 8px 0px 0px 0px;
  border-top: 2px solid #003049;
  justify-content: flex-start;

  &::-webkit-scrollbar {
    height: 4px;
    width: 3px;
    background-color: transparent !important;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #003049 !important;
    border-radius: 8px;
  }

`;

const DivBoxContainer = styled.div`
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  width: -webkit-fill-available;
  height: auto;
`;

const ContainerBtnEditar = styled.img`
  position: relative;
  height: 25px;
  font-family: 'Montserrat',sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
  background-color: #00000054;
  left: unset;
  padding: 5px;
  top: -135px;
  margin-right: 16px;
  margin-left: 93%;
  width: -webkit-fill-available;
  border-radius: 4px;
  filter: drop-shadow(0.2px 0.2px 0px #00000099);
  text-align: center;
`;


const TextNameUser = styled.span`
  width: auto;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 22px;
  color: #003049;
`;

const DivColumn1 = styled.div`
  display:flex;
  flex-direction:column;
  align-items:flex-start;
  justify-content:center;
  width: -webkit-fill-available;
  margin: 65px 0% 0% 0%;
  padding: 16px 16px;
  border-radius:8px;
  background-color:#FFFFFF;
  gap:16px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 50px;
`;

const DivColumnRelative = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  width: auto;
  z-index: 2;
  height: 0px !important;
  top: 0px;
  align-self: flex-start;
  margin-left: 16px;

  @media only screen and (min-width:1100px) and (max-width:1380px) {
    zoom:0.85
  }

  @media only screen and (min-width:0px) and (max-width:1100px) {
      margin-left: 0px;
      align-self: center;
      zoom:0.85;
  }
`;

const DivContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: -webkit-fill-available;
  height: 180px;
  max-height: 180px;
  margin: 0px 0%;
  gap:0px;
`;

const DivContentImage = styled.img`
  height: 150px;
  width: 100%;
  background-color: #FFFFFF;
  object-fit: cover;
  border-radius: 8px 8px 8px 8px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 50px;
`;

const ImageProfile = styled.img`
  height: 100px;
  width: 100px;
  background-color: #FFFFFF;
  object-fit: cover;
  border-radius: 100%;
  filter: drop-shadow(2px 4px 6px #cecece);
`;


const Text1 = styled.span`
  width: auto;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 13px;
  color: #003049;
`;